module.exports = __webpack_public_path__ + "static/img/admin-login-logo.691190e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/admin-login-logo.png
// module id = FeMt
// module chunks = 1